// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"03f2198f","455":"be41338b"}[chunkId] + ".chunk.js";
};